import React from "react";
import { Spinner, Button, Row, Col } from "reactstrap";
import LeadsImportStep2TableItem from "./LeadsImportStep2TableItem";

const LeadsImportStep2 = ({
  step,
  loading,
  onSubmit,
  tableData,
  appendableColumns,
  setAppendableColumns,
  onTableColumnUnSelect,
  onTableColumnSelect,
}) => {
  if (step === 1) {
    return (
      <div className="px-md-5 w-100">
        <div className="d-flex align-items-center gap-2 mb-2" style={{ opacity: 0.5 }}>
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "#697277",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            2
          </div>
          <div style={{ fontSize: "20px", fontWeight: 500, color: "#697277" }}>
            Check table mapping
          </div>
        </div>
      </div>
    );
  }

  if (tableData?.columns?.length < 4) {
    return (
      <div className="text-center" style={{ fontSize: "20px", fontWeight: 500, color: "#697277" }}>
        Your data must have atleast 4 columns
      </div>
    );
  }

  return (
    <div className="px-md-5 pb-5 w-100">
      <div className="d-flex align-items-center gap-2 mb-2">
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: "#697277",
            color: "white",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: 500,

          }}
        >
          2
        </div>
        <div style={{ fontSize: "20px", fontWeight: 500, color: "#697277" }}>
          Check table mapping
        </div>
      </div>

      <Row className="d-none d-md-flex pt-2 px-3">
        {["FILE HEADER", "DATA", "APPEND FIRST"].map((text, index) => (
          <Col key={index}>
            <div style={{ fontSize: "18px", fontWeight: 500, color: "#697277", textAlign: "left" }}>
              {text}
            </div>
          </Col>
        ))}
      </Row>

      {tableData?.columns?.map((column, i) => {
        const allTableData = tableData?.data;
        let tableItem = { column: column?.Header, data: [] };

        if (column?.appendedValue) {
          tableItem.appendedValue = column?.appendedValue;
        }

        for (let i = 0; i < allTableData?.length; i++) {
          if (allTableData[i][`${column?.Header}`]) {
            tableItem = {
              ...tableItem,
              data: [...tableItem?.data, allTableData[i][`${column?.Header}`]],
            };
            if (tableItem?.data.length === 3) break;
          }
        }

        return (
          <LeadsImportStep2TableItem
            key={i}
            table={tableItem}
            appendableColumns={appendableColumns}
            onAppendableColumnsChange={setAppendableColumns}
            onTableColumnUnSelect={onTableColumnUnSelect}
            onTableColumnSelect={onTableColumnSelect}
          />
        );
      })}

      <div className="py-4 d-flex justify-content-center align-items-center">
        <Button color="primary" disabled={loading} onClick={onSubmit}>
          <span style={{ fontSize: "15px", fontWeight: 500, textTransform: "none" }}>
            Confirm your Import
          </span>
          {loading && <Spinner size="sm" color="light" className="ms-2" />}
        </Button>
      </div>
    </div>
  );
};

export default LeadsImportStep2;
